import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CalendarOptions, DateSelectArg, EventClickArg, EventApi, FullCalendarModule , FullCalendarComponent } from '@fullcalendar/angular';
import { Draggable } from '@fullcalendar/interaction';
import { FormControl, FormGroup } from '@angular/forms';
import { AccountService } from 'app/_services/account.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { SubmissionService } from '../_services/submission.service';
import { ClientService } from 'app/_services/client.service';
import { BuildingService } from 'app/_services/building.service';
import { NoteService } from 'app/_services/note.service';
import * as moment from 'moment'; 

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {
  @ViewChild('calendar', { static: false }) calendar!: FullCalendarComponent;

  contactUUID: string = "";
  salesList: any = [];
  saleAccountId: any;
  submissionsList: any[] = [];
  submissionsNotAssignedList: any[] = [];

  submitSubmissionInfoSuccess: boolean = false;
  submitBuildingInfoSuccess: boolean = false;
  showMessage: boolean = false;
  messageSuccess: string = "Mise à jour effectuée";
  messageError: string = "Une erreur c'est produit";

  submissionId: number = 0;
  eventSubmissionInfo: any = {};
  eventBuildingInfo: any = [];
  clientId: number = 0;
  clientInfo: any = [];
  buildingId: number = 0;
  popover_on: any = false;

  followUps: any = [];
  oldStartDate: string = "";
  oldEndDate: string = "";
  startDate: string = "";
  endDate: string = "";
  eventModal: any;
  eventName: string = "";
  submissionInfo: any = [];
  modalTitle: string = "";
  eventAddress: string = "";
  eventStartDate: any;
  eventEndDate: any;
  calendarApi: any;
  isSearch: boolean = false;
  p: number = 0;
  total: number = 0;
  no_results_message: string = "";

  /*------------------------------------------
  --------------------------------------------
  Define calendarOptions
  --------------------------------------------
  --------------------------------------------*/
  calendarOptions: CalendarOptions = {
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay'
    },
    buttonText: {
      today: 'Aujourdhui',
      month: 'Mois',
      week: 'Semaine',
      day: 'Jour',
      list: 'Liste',
    },
    height: 'auto',
    eventDisplay:'block',
    initialView: 'timeGridWeek',
    weekends: true,
    firstDay: 1,
    editable: true,
    selectable: true,
    selectMirror: true,
    dayMaxEvents: 99,
    lazyFetching: true,
    progressiveEventRendering: false,
    droppable: true, // this allows things to be dropped onto the calendar
    defaultTimedEventDuration: '01:00:00',
    eventMinHeight: 30,
    slotMinTime: "06:00:00",
    slotMaxTime: "19:00:00",
    slotLabelInterval: "00:30",
    slotDuration:'00:30:00',
    //eventShortHeight:60,
    forceEventDuration: true,
    eventOverlap: false,
    slotEventOverlap: false,
    eventDurationEditable:true,
    //slotMinTime: '8:00',
    drop: this.handleDropEvent.bind(this),
    eventDrop: this.handleDragEvent.bind(this),
    eventReceive: this.handleAddEvent.bind(this),
    eventClick: this.handleEventClick.bind(this),
    dateClick: this.handleDateClick.bind(this), // bind is important!
    datesSet: this.handleEvents.bind(this),
    eventResize: this.eventResize.bind(this),
    eventDragStart: function(a) {
      console.log("Drag start", a);
    },
    eventDragStop: function(a) {
      console.log("Drag stop CV", a);
    
    },
  };

  editCalendarForm: FormGroup = new FormGroup({
    submissions_by_sales: new FormControl(""),
  })

  searchSubmissionForm: FormGroup = new FormGroup({
    search_submission: new FormControl("")
  })

  constructor(
    private account: AccountService,
    private tokenStorage: TokenStorageService,
    private submission: SubmissionService,
    private submissions: SubmissionService,
    private clients: ClientService,
    private notes: NoteService,
    private buildings: BuildingService,
  ) { }


  ngOnInit(): void {
    this.contactUUID = this.tokenStorage.getToken() || "";

    this.editCalendarForm.addControl('submissions_by_sales', new FormControl(""));
    this.getSalesAccount();
    this.getSubmissions();
    //this.editCalendarForm.controls['submissions_by_sales'].patchValue(17);
    //this.calendarApi = this.calendar.getApi();
    //console.log('form: ', this.editCalendarForm.patchValue['submissions_by_sales']   );
    
    //this.editCalendarForm.controls['submissions_by_sales'].patchValue(17);
    console.log('sale',this.editCalendarForm.controls['submissions_by_sales'].value);
   //this.onChange(17);

  }

  ngOnChanges() {
    ///** WILL TRIGGER WHEN PARENT COMPONENT UPDATES '**
  
     console.log('SOMETHING CHANGED');
  }  
/*
  ngAfterViewInit(): void {
   
    this.onChange();
  }
*/
  onSubmit(formValues: any): void {
    console.log("All values ", formValues)

  }

  // Fetches all salesman in the system
  getSalesAccount(): void {
    this.account.getSales$(this.contactUUID).subscribe({
      next: (data: any) => {
        this.salesList = data

        for (let i = 0; i < data.length; i++) {
          let profileId = data[i].account_id;

          this.account.getAccountProfile$(profileId, this.contactUUID).subscribe((profile: any) => {
            this.salesList[i].profile_id = profile.profile_id;
            this.salesList[i].first_name = profile.first_name;
            this.salesList[i].last_name = profile.last_name;
          });
        }
        this.editCalendarForm.controls['submissions_by_sales'].setValue(6);
        this.onChange();
      },
      error: (err: any) => {
        console.log("Something went wrong searching sales: ", err.statusText)
      }
    })
  }

  // Fetches submissions not assigned and wihtout planning
  getSubmissions(): void {
    // Searching criterias
    // is_signed = false
    // is_scheduled = false
    // is_job_planned = false
    // limit = 9999
    //"state?is_scheduled=false&is_signed=false&is_job_planned=false&is_refused=false&limit=9999";
    let searchInfo = "state?is_scheduled=false&limit=9999";

    this.submission.searchStateSubmission$(this.contactUUID, searchInfo, 0).subscribe({
      next: (data: any) => {
        console.log("submissions Not Assigned List", data)
        this.submissionsNotAssignedList = data.records

        let draggableEl = document.getElementById('external-events')!;

        new Draggable(draggableEl, {
          itemSelector: '.client-event',
          eventData: function (eventEl) {
            return {
              id: eventEl.id,
              title: eventEl.innerText,
              create: false
            };
          }
        });
      },
      error: (err: any) => {
        console.log("Something went wrong with searching the submissions: ", err)
      }
    })
  }
  
  // When selecting the dropdown
  onChange(): void {

   

      //this.calendarApi = this.calendar.getApi();
     // console.log('vendeur: ', event.target.value, this.editCalendarForm.controls['submissions_by_sales'].value);
      const dates = this.calendarApi.getCurrentData();

      this.saleAccountId = this.editCalendarForm.controls['submissions_by_sales'].value; //event.target.value;
      //this.startDate = moment(dates.dateProfile.activeRange!.start).format('YYYY-MM-DD');
      console.log('start date',this.startDate);
      console.log('sales account', this.saleAccountId);

      //console.log(this.calendarApi.currentData.currentDate );
      //console.log('dates', this.startDate, this.saleAccountId, this.contactUUID);
    
      this.notes.getCalendrierVendeur$(this.contactUUID, Number(this.saleAccountId), moment(this.startDate).format('YYYY-MM-DD')).subscribe({
        next: (data: any) => {
          console.log("Notes list ", data)
          this.submissionsList = [];

          for(let i = 0; i < data.length; i++) {
            let color: string = "#3788d8";
            let border_not_notified: string = "";

           // console.log('notified', data[i].notified);


            if (data[i].is_sent) {
              //color ="#36c";
            }
 
            if (data[i].is_accepted) {
             // color = "#006633";//green
            }
            
            if (data[i].has_invoice) {
              color = "#006633";//green
            }
            
            if (data[i].is_refused) {
              color = "#bb0200";//red
            }

            if(!data[i].notified){
              border_not_notified = " event-border-red"; //red border
            }
            
         

            let address = "#" + 
                          data[i].submission_no +
                          "\r\n" + 
                          data[i].client_first_name +
                          " " +
                          data[i].client_last_name +
                          "\r\n" + 
                          data[i].address + 
                          " " + 
                          data[i].address2 + 
                          ", " + 
                          data[i].city + "" ;
             
           // console.log('client: ',address, color);
            
            this.submissionsList.push(
              {
                "id": data[i].note_id,
                "title": address,
                "start": moment(data[i].start_date).format('YYYY-MM-DD HH:mm'), // We need to select a date
                "end": moment(data[i].end_date).format('YYYY-MM-DD HH:mm'),
                "backgroundColor": color,
                "extendedProps": data[i],
                "className": 'event-style' + border_not_notified,
              }
            )
          }

          console.log("calendar list", this.submissionsList);
          this.calendarOptions.events = this.submissionsList;

          //console.log("this.calendarOptions.events ", this.calendarOptions.events)
        },
        error: (err: any) => {
          console.log("Something went wrong with getting the calendar submissions: ", err)
        }
      })
  }

  handleDropEvent(event: any) {
    console.log('dropping event ', event.dateStr);
    // Delete the submission of the left menu
    event.draggedEl.parentElement.remove();

    const draggedEventId = event.draggedEl.id;
    const draggedEventDate = event.dateStr;

    console.log('dropped event ', event);

    this.getEventSubmission(event, draggedEventId, draggedEventDate);
  }

  handleAddEvent(event: any) {
    console.log('TRYING TO REMOVE ', event.draggedEl.id);

    event.draggedEl.parentElement.remove();
  }

  eventResize(eventDragged:any) {
    console.log('resizing event');
    const draggedEventId = eventDragged.event._def.extendedProps.submission_id;
    var endDate = eventDragged.event.endStr;
    var startDate = eventDragged.event.startStr;

    //console.log('stat+end date:',startDate+ ' '+ endDate);
    this.updateNoteRV(draggedEventId, eventDragged);

  }

  handleDragEvent(eventDragged: any) {
    const draggedEventId = eventDragged.event._def.extendedProps.submission_id;
    const draggedEventDate = eventDragged.event.startStr;

    console.log('dragging event ');

    this.updateNoteRV(draggedEventId, eventDragged);
  }

  updateNoteRV(submissionId: number, event: any) {
    const submission_id = submissionId;
    const sale_acc_id = this.saleAccountId;

    const noteInfos = event.event;

    console.log('noteInfos moved ', noteInfos );
    console.log('new end date: ', event.event.endStr);

    let noteInfo = {
      "note_id": noteInfos.id,
      "updated": noteInfos._def.extendedProps.updated,
      "start_date": event.event.startStr,
      "end_date": event.event.endStr,
    }

    this.notes.updateNote$(this.contactUUID, noteInfo).subscribe({
      next: (data: any) => {
        //console.log("updated dragged rv note ", data.updated);
        //console.log("old updated dragged rv note ", noteInfos._def.extendedProps.updated);
        //noteInfos._def.extendedProps.updated = data.updated;
        noteInfos.setExtendedProp( 'updated', data.updated );
        //console.log("event", noteInfos)
        //console.log("new set rv note ", noteInfos._def.extendedProps.updated);
        
      },
      error: (err: any) => {
        console.log("Something went wrong updating the rv note: ", err)
      }
    })
    
    
  }

   //register dropped date event, assign vendor
  getEventSubmission( draggedEvent:any, submissionId: number, eventDate: string) {
    this.submissions.getSubmission$(submissionId, this.contactUUID).subscribe({
      next: data => {
        this.submissionId = data.submission_id;
        this.clientId = this.saleAccountId;
        this.buildingId = data.building_id;

        this.getEventBuildingInfo(eventDate);
        
        this.eventSubmissionInfo = {
          "submission_no": data.submission_no,
          "client_id": data.client_id,
          "sales_account_id": this.saleAccountId === 0 ? data.sales_account_id : this.saleAccountId,
          "active": data.active,
          "updated": data.updated
        }

        let eventSubmissionStateInfo = {
          "updated": data.state_updated,
          "submission_state_id" : data.submission_state_id,
          "is_scheduled": true,
        }
  
        console.log('eventSubmissionStateInfo : ', eventSubmissionStateInfo);
       

        // console.log("EVENTSUBMISSIONINFO ", this.eventSubmissionInfo)
        this.submitSubmissionInfo(this.eventSubmissionInfo);

        this.submitSubmissionStateInfo(eventSubmissionStateInfo);

        //craete a note rendez vous
        this.getNoteRV(eventDate, this.submissionId, this.clientId);

      },
      error: err => {
        console.log("Something went wrong fetching submission: ", err)
      }
    });
  }

  getNoteRV(eventDate: string, submissionId: number, salesAccountId: number): void {
    console.log('saving Rv note on', eventDate);

    const submissionid = submissionId;
    const salesid = salesAccountId;
    //moment(new Date(oneProposition.proposition_date)).locale('fr').format('D MMMM YYYY HH:mm')
    var startdate = moment(new Date(eventDate));
    var enddate_adjusted = moment(new Date(eventDate)).add(1, 'hours');
    //var enddate_adjusted = enddate.add(moment.duration(2, 'hours')).toISOString();

    console.log('saved note startdate ', startdate);
    
    let noteInfo: any = {
      "note_type_id": 3,
      "note_entity_id": 2,
      "entity_id": submissionid,
      "subject": '',
      "body": '',
      "sales_account_id": salesid,
      "start_date": startdate,
      "end_date":  enddate_adjusted,
    }

    this.notes.addSubmissionNote$(this.contactUUID, noteInfo).subscribe({
      next: (data: any) => {
        console.log("Note RV added Data ", data);
        this.popover_on = false;
        this.calendarApi.refetchEvents();
        this.onChange();
      },
      error: (err: any) => {
        console.log("Something went wrong updating the note: ", err)
      }
    })
    
  }

  getEventBuildingInfo(eventDate: string): void {
    this.buildings.getBuilding$(this.contactUUID, this.buildingId).subscribe({
      next: building => {
        this.eventBuildingInfo = {
          "building_id": this.buildingId,
          "updated": building.updated,
          "submission_id": building.submission_id,
          "description": building.description,
          "roof_date": building.roof_date,
          "roof_description": building.roof_description,
          "roof_access": building.roof_access,
          "build_date": eventDate,
          "purchase_date": building.owner_since,
          "is_new": building.is_new,
          "address": building.address,
          "address2": building.address2,
          "city": building.city,
          "province": building.province,
          "country": building.country,
          "postalcode": building.postalcode
        }

        // console.log("EVENTBUILDINGINFO ", this.eventBuildingInfo)
        this.submitBuildingInfo(this.eventBuildingInfo);
      },
      error: err => {
        console.log("Something went wrong fetching building info: ", err)
      }
    });
  }

  submitSubmissionInfo(info: any): void {
    this.submissions.updateSubmission$(this.submissionId, this.contactUUID, info).subscribe({
      next: data => {
        console.log("Success updating the submission: ", data)
        this.submitSubmissionInfoSuccess = true;
      },
      error: err => {
        console.log("Something went wrong while updating the submission: ", err)
        this.submitSubmissionInfoSuccess = false;
      }
    });
  }

//register scheduled state for event / submission
  submitSubmissionStateInfo(info: any): void {
    this.submissions.updateSubmissionState$(this.submissionId, this.contactUUID, info).subscribe({
      next: data => {
        console.log("Success updating the submission state: ", data)
      },
      error: err => {
        console.log("Something went wrong while updating the submission state: ", err)
      }
    });
  }

  submitBuildingInfo(info: any): void {
    this.buildings.updateBuilding$(this.contactUUID, info).subscribe({
      next: data => {
        console.log("Success updating the building: ", data)
        this.submitBuildingInfoSuccess = true;


        if (this.submitBuildingInfoSuccess === true && this.submitBuildingInfoSuccess === true) {
          this.showMessage = true;
        }
        else {
          this.showMessage = false;
        }
      },
      error: err => {
        console.log("Something went wrong while updating the building info: ", err)
        this.submitBuildingInfoSuccess = false;
      }
    })
  }

  handleDateClick(event: any): void {
    console.log("handleDateClick ", event);
    this.closePopovers();
  }

  handleEvents(events: any): void {
    console.log('handling events');
    
    this.calendarApi = this.calendar.getApi();
    const dates = this.calendarApi.getCurrentData();
    this.startDate = moment(dates.dateProfile.activeRange!.start).format('YYYY-MM-DD HH:mm');
    this.endDate = moment(dates.dateProfile.activeRange!.end).format('YYYY-MM-DD HH:mm');

   // console.log('this.startDate',  this.startDate);
    //console.log('this.endDate',  this.endDate);
    this.onChange();

    if (this.oldStartDate !== this.startDate) {
      this.oldStartDate = this.startDate
    }

    this.closePopovers();
    //this.onChange();
  }

  handleEventClick(clickInfo: EventClickArg): void {
    const submissionInfo = clickInfo.event._def.extendedProps;

    this.popover_on = !this.popover_on;

    console.log("clickInfo", clickInfo)
    console.log("clickInfo", submissionInfo)
    console.log("this.popover_on", this.popover_on);

    this.closePopovers();

    //@ts-ignore
    const eventPopover = new bootstrap.Popover(clickInfo.el, {
      animation: true,
      container: "body",
      html: true,
      placement: "auto",
      trigger: "focus",
      sanitize: false,
      title: '', //'clickInfo.event.title',
      content:  
            '<div class="d-flex"><span class="">' + "#" + submissionInfo['submission_no'] + " " + submissionInfo['client_first_name'] + " " + submissionInfo['client_last_name'] + '</span></div>' +
            '<div class="d-flex"><span class="mb-2 address-popover">' + submissionInfo['address'] + ' ' + submissionInfo['city'] + '</span></div>' +
              '<div class="buttons-wrapper">' +
              '<span class="float-start col-1 ms-0">'+
                  '<button type="button" id="deleteSuivis" role="button" class="btn-delete btn-delete-popover" title="supprimer rdv vendeur"><i class="bi bi-file-x-fill"></i></button>'+
              '</span>' +  
              '</div>' + 
              '<div class="d-flex justify-content-end action-icons">' +
              '<a type="button" class="btn btn-outline-secondary left-action-btn" href="/client/' + submissionInfo['client_id'] + '/editer">' +
                  '<i class="bbi bi bi-person" title="Modifier le client"></i>' +
                '</a>' +
                '<a type="button" class="btn btn-outline-secondary middle-action-btn" href="/soumission/' + submissionInfo['entity_id'] + '/editer">' +
                  '<i class="bi bi-pencil-square" title="Voir la soumission"></i>' +
                '</a>' +
                ' <button type="button"  id="sendSalesNotification" class="btn btn-outline-secondary right-action-btn" >' +
                  '<i class="bi bi-envelope-fill" title="Envoyer la soumission"></i>' +
                '</button>' +
            '</div>'
      
             
    })

    if (this.popover_on) {
      eventPopover.show();

      const delEl = document.getElementById("deleteSuivis");
      delEl!.onclick = () => { 

        if(confirm("Voulez-vous supprimer ce rendez-vous? ")) {
            const note_id = submissionInfo['note_id']; 

            console.log("delete suivi: ", note_id);
      
            let noteInfo: any = {
              "note_id": note_id,
            }
            this.deleteSuivisNote(note_id, noteInfo);
        }

      };

      const notifyEl = document.getElementById("sendSalesNotification");
      notifyEl!.onclick = () => { 
        const note_id = submissionInfo['note_id']; 

        console.log("notify suivi: ", note_id);
  
        let noteInfo: any = {
          "note_id": note_id,
        }
        this.sendSalesNotification(this.saleAccountId, note_id);

      };
    }
    else {
      this.closePopovers();
    }
  }

  
  holdSubmission(submission_id: number): void {
    console.log("click on hold ", );

    this.submission.putOnHoldSubmission$(this.contactUUID, submission_id).subscribe({
      
      next: data => {
        console.log("Success submission on hold: ", data);
        window.location.reload();
      },
      error: err => {
          console.log("Something went wrong while deleting suivi RV: ", err.error.errors)
      }
      
    });
  }


  deleteSuivisNote(note_id: number, noteInfo: any): void {

    this.notes.deleteNote$(this.contactUUID, note_id, noteInfo).subscribe({
      
      next: data => {
        console.log("Success deleting suivi RV: ", data);
        this.closePopovers();
        this.onChange();
        //window.location.reload();
        //refresh div list on left
        let searchInfo = "state?is_scheduled=false&limit=9999";

        this.submission.searchStateSubmission$(this.contactUUID, searchInfo, 0).subscribe({
          next: (data: any) => {
            console.log("submissions Not Assigned List", data)
            this.submissionsNotAssignedList = data.records
          },
          error: (err: any) => {
            console.log("Something went wrong with searching the submissions: ", err)
          }
        })
       
      },
      error: err => {
          console.log("Something went wrong while deleting suivi RV: ", err.error.errors)
      }
      
    });
  }
   
  sendSalesNotification (sales_acc_id: number, note_id: number): void {
      //alert("sendSalesNotification");
      console.log('sending email noteId', note_id, ' sales acc id ', sales_acc_id);
   
      this.account.notifySalesAppoitnment$(this.contactUUID, sales_acc_id, note_id).subscribe({
        next: (data: any) => {
          console.log("sent email ",data);
          this.closePopovers();
          this.onChange();
        },
        error: (err: any) => {
          console.log("Something went wrong sending email: ", err.statusText)
        }
      });

  }

  openModal(info: any): void {
    console.log("info ", info)
  }

  closePopovers(): void {
    const popoverTriggerList = document.querySelectorAll('.bs-popover-auto');
    for (let i = 0; i < popoverTriggerList.length;i++) {
        console.log("popover", popoverTriggerList[i])
        popoverTriggerList[i].remove();
    }
    this.popover_on = true;
  }

  onSubmitSearch(values: any): void {
    this.p = 0;
    this.searchSubmission(values.search_submission);
  }

  searchSubmission(search: string): void {
    this.isSearch = true;

    this.submissions.searchSubmissionNoLimit$(this.contactUUID, search, this.p).subscribe({
      next: (data: any) => {
        console.log('search results: ', data.records);
        this.submissionsNotAssignedList = data.records;
        this.total = data.count;
        if(this.total == 0){ this.no_results_message = 'Aucun résultat de la recherche: ' + search;}
      },
      error: (err: any) => {
        console.log("Something went wrong searching submissions: ", err.statusText)
      }
    });
  }
}
